let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dtyuX")).then(() => parcelRequire('dxsFu'));